import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";

export default function AppShell({ children }) {
  const fire = useLocation().pathname.startsWith("/incendio");
  return (
    <div className={`flex min-h-screen min-w-0 bg-transparent text-foreground ${fire ? "fire-active-shell" : ""}`} data-testid="app-shell">
      <Sidebar />
      <main className="flex min-h-screen min-w-0 flex-1 flex-col overflow-x-hidden" data-testid="main-content">
        {children}
      </main>
    </div>
  );
}

